import requests from './httpService';

const TeacherReportService = {
  getTemplate(params) {
    return requests.get('/teacher-report/template', { params });
  },
  putTemplate(body) {
    return requests.put('/teacher-report/template', body);
  },
  listClassRatings(params) {
    return requests.get('/teacher-report/class-ratings', { params });
  },
  putRating(body) {
    return requests.put('/teacher-report/rating', body);
  },
};

export default TeacherReportService;
